<template>
  <button
    v-if="$variable('zendesk.enable') && mounted"
    ref="zendesk"
    class="zendesk"
    :aria-label="$string('zendesk.accessibility.open')"
    @click="initZendesk"
  >
    <span class="zendesk__icon-wrapper">
      <svg
        aria-hidden="true"
        class="icon icon__zendesk"
        viewBox="0 0 15 16"
        x="0"
        xml:space="preserve"
        y="0"
      >
        <path d="M1.3,16c-0.7,0-1.1-0.3-1.2-0.8c-0.3-0.8,0.5-1.3,0.8-1.5c0.6-0.4,0.9-0.7,1-1c0-0.2-0.1-0.4-0.3-0.7c0,0,0-0.1-0.1-0.1 C0.5,10.6,0,9,0,7.4C0,3.3,3.4,0,7.5,0C11.6,0,15,3.3,15,7.4s-3.4,7.4-7.5,7.4c-0.5,0-1-0.1-1.5-0.2C3.4,15.9,1.5,16,1.5,16 C1.4,16,1.4,16,1.3,16z M3.3,10.9c0.5,0.7,0.7,1.5,0.6,2.2c0,0.1-0.1,0.3-0.1,0.4c0.5-0.2,1-0.4,1.6-0.7c0.2-0.1,0.4-0.2,0.6-0.1 c0,0,0.1,0,0.1,0c0.4,0.1,0.9,0.2,1.4,0.2c3,0,5.5-2.4,5.5-5.4S10.5,2,7.5,2C4.5,2,2,4.4,2,7.4c0,1.2,0.4,2.4,1.2,3.3 C3.2,10.8,3.3,10.8,3.3,10.9z" />
      </svg>
    </span>

    <span v-if="!isMobile">
      {{ $string('zendesk.help') }}
    </span>
  </button>
</template>

<script>

import { mapState } from 'vuex'

/**
 * Vue: Zendesk
 * -----------------------------------------------------------------------------
 * Lazyload zendesk.
 *
 */

export default {
  name: 'Zendesk',

  data() {
    return {
      loading: false,
      mounted: true,
      zdSrc: 'https://static.zdassets.com/ekr/snippet.js?key=8b4560db-df1e-498a-9624-c3bef90918ed',
    }
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),
  },

  mounted() {
    this.setEventBusListeners()
  },

  methods: {

    initZendesk() {
      if (this.loading) {
        return
      }
      this.loading = true
      this.$refs.zendesk.innerHTML = this.$icon('misc.loading')
      const script = document.createElement('script')
      script.id = 'ze-snippet'
      script.async = true
      script.src = this.zdSrc
      document.body.appendChild(script)

      this.zdReady = setInterval(() => {
        if (window.zE && window.zE.activate) {
          clearInterval(this.zdReady)
          window.zE.activate()
          setTimeout(() => {
            this.mounted = false
          }, 1000)
        }
      }, 50, null)
    },

    setEventBusListeners() {
      cnvs.EventBus.listen('initZendesk', this.initZendesk)
    },
  },
}
</script>

